var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-advance-select",
    _vm._g(
      _vm._b(
        {
          ref: "cargoAdvanceSelect",
          attrs: {
            "select-type": _vm.selectType,
            "method-params": _vm.methodParams,
            cache: _vm.cache,
            "default-value": _vm.defaultValue
          }
        },
        "cargo-advance-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }